import { createApiModule, createQueryString } from 'api/common/utls';
import apiClient from '../client';

const PULA_BASE = '/pula_integration';

// Define API methods for Pula Farmland CRUD
const apiMethods = {
  /**
   * Get dynamic form configuration for Pula Farmland
   * @param {boolean} isEdit - Whether in edit mode
   * @param {string} farmId - Farm ID (UUID, required for edit)
   * @param {string} farmerId - Farmer ID (optional for create)
   * @param {boolean} offline - Whether in offline mode
   */
  getForm: (isEdit, farmId, farmerId, offline = false) => {
    const queryParams = {
      is_edit: String(Boolean(isEdit)),
      offline: String(Boolean(offline))
    };

    if (farmId) queryParams.farm_id = farmId;
    if (farmerId) queryParams.farmer_id = farmerId;

    const queryString = createQueryString(queryParams);
    return apiClient.get(`${PULA_BASE}/form${queryString}`);
  },
  createFarmland: data => {
    return apiClient.post(`${PULA_BASE}/farmland`, data);
  },

  /**
   * Update an existing Pula Farmland record
   * @param {string} farmId - Farm ID (UUID)
   * @param {Object} data - Updated farmland data
   */
  updateFarmland: (farmId, data) => {
    return apiClient.put(`${PULA_BASE}/farmland/${farmId}`, data);
  },

  /**
   * Get Pula Farmland details by ID
   * @param {string} farmId - Farm ID (UUID)
   */
  getFarmland: farmId => {
    return apiClient.get(`${PULA_BASE}/farmland/${farmId}`);
  },

  /**
   * Get Pula compliance discovery status for a NIN
   * @param {string} nin - Farmer's NIN
   */
  getComplianceStatus: nin => {
    return apiClient.get(`${PULA_BASE}/compliance-status/${nin}`);
  },

  exportPolygon: (farmId, format) => {
    return apiClient.get(`${PULA_BASE}/export-polygon/${farmId}/${format}`, {
      responseType: 'blob'
    });
  },

  /**
   * Export procurement polygons in specified format
   */
  exportPolygonProcurement: (procurementId, format) => {
    return apiClient.get(
      `${PULA_BASE}/export-polygon-procurement/${procurementId}/${format}`,
      {
        responseType: 'blob'
      }
    );
  },

  /**
   * Poll Orbify for plot status and update database
   */
  pollStatus: () => {
    return apiClient.post(`${PULA_BASE}/poll-status`);
  },

  /**
   * Update the status of a Pula Farmland record
   * @param {string} farmId - Farm ID (UUID)
   * @param {boolean} isActive - true for Active, false for Inactive
   */
  updateFarmlandStatus: (farmId, isActive) => {
    const newStatus = isActive ? 'Active' : 'Inactive';
    return apiClient.put(`${PULA_BASE}/farmland/status/${farmId}`, {
      status: newStatus
    });
  }
};

// Create API module with error handling
export const pulaFarmlandApi = createApiModule(apiMethods);
